import { render, staticRenderFns } from "./ShowPoll.vue?vue&type=template&id=f547afd2&scoped=true&"
import script from "./ShowPoll.vue?vue&type=script&lang=ts&"
export * from "./ShowPoll.vue?vue&type=script&lang=ts&"
import style0 from "./ShowPoll.vue?vue&type=style&index=0&id=f547afd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f547afd2",
  null
  
)

export default component.exports